import styled from '@emotion/styled';
import { Tabs } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Spacings } from '@styles/index';

const StyledTabs = styled(Tabs)`
  height: fit-content;
  border-bottom: 1px solid var(--color-divider);
  &.MuiTabs-root {
    .MuiTabs-scroller {
      .MuiTabs-indicator {
        background-color: ${({ $selectedTabColor }) => $selectedTabColor};
        height: ${Spacings.SPACING_1B};
      }
      .MuiTabs-flexContainer {
        .MuiButtonBase-root {
          .MuiTab-wrapper {
            font-weight: 600;
            font-size: 16px;
            line-height: 150%;
            text-transform: none;
          }
        }
      }
    }
  }
`;

export default StyledTabs;

StyledTabs.propTypes = {
  $selectedTabColor: PropTypes.string
};

StyledTabs.defaultProps = {
  $selectedTabColor: 'var(--color-base-fill)'
};
